export default "__VITE_ASSET__CQYTzaPv__"